import { render, staticRenderFns } from "./SLRPerson1.vue?vue&type=template&id=6fd81e8c"
import script from "./SLRPerson1.vue?vue&type=script&lang=js"
export * from "./SLRPerson1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports